package songwritersnotebook.app.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement

@Composable
actual fun rememberFileSaverLauncher(
    suggestedName: String,
    mimeType: String,
    onFileSelected: (String) -> Unit
): () -> Unit {
    return remember(suggestedName, mimeType) {
        {
            // On Web, we can't easily "pick" a location to save before generating data.
            // Usually, we generate a Blob and trigger a download.
            // This launcher will just notify the caller that it's "ready" by giving a dummy path,
            // or we might need to rethink this API for Web.
            // For now, let's return a unique ID that the caller can use to trigger an actual download.
            onFileSelected("web_download_$suggestedName")
        }
    }
}

/**
 * Utility to trigger an actual browser download from a ByteArray.
 */
fun triggerWebDownload(fileName: String, bytes: ByteArray, mimeType: String) {
    val blob = org.w3c.files.Blob(arrayOf(bytes), org.w3c.files.BlobPropertyBag(type = mimeType))
    val url = SnBridge.createObjectURL(blob)
    val anchor = document.createElement("a") as HTMLAnchorElement
    anchor.href = url
    anchor.download = fileName
    anchor.click()
    SnBridge.revokeObjectURL(url)
}
